"use client"

import { useEmailIntegrations } from "@/hooks/api/email_integrations"
import { useFetchLayoutCustomizations } from "@/hooks/api/layout-customizations/queries"
import { useUnreadNotificationsCount } from "@/hooks/api/notifications/queries"
import { useFetchCurrentUser } from "@/hooks/api/users"
import { IntegrationRequestEmailCtaGate } from "@/components/integration-requests/integration-request-email-cta"

export const useGlobalQueries = () => {
  useFetchCurrentUser()
  useEmailIntegrations()
  useUnreadNotificationsCount()
  useFetchLayoutCustomizations()
}

const GlobalQueriesWrapper = () => {
  useGlobalQueries()
  return <IntegrationRequestEmailCtaGate />
}

export default GlobalQueriesWrapper
